import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OneFeildMasterService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }
  
   OneFeildLoad(LocDetail: any) {
   return this.http.post<any>(environment.API_URL + `OneFeildMasters/OneFeildMasterDetails`,
      this.session.SetClass(LocDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
   OneFieldInsert(ofi: any) {
    return this.http.post<any>(environment.API_URL + `OneFeildMasterInsert/OneFeildMasterInsert`,
      this.session.SetClass(ofi)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  
}
